import React, { useContext } from 'react';
import styled from 'styled-components';
import noop from 'lodash/noop';

import FormContext from 'src/presentation/contexts/FormContext';
import useCreateNewNode from 'src/presentation/components/pages/ivr/hooks/useCreateNewNode';
import { Button } from 'src/presentation/components/agent_desktop_components';
import { H1 } from '@ad-scripts/presentation/components/common/headers';
import { IvrEditorContext } from 'src/presentation/components/pages/ivr/IvrEditor';

const EmptyIvrState = ({ disabled }) => {
  const { workingState, onBlur } = useContext(FormContext);
  const { onNodeSelected } = useContext(IvrEditorContext);

  const { selectNodeTypeModal, setShowSelectNodeTypeModal } = useCreateNewNode({
    attr: 'rootNodeId',
    workingState,
    onBlur,
    stayOnParentNodeAfterCreation: false,
    onSelectNode: onNodeSelected,
    onChange: noop,
    nodeList: [],
    limitNodeTypesTo: undefined,
  });

  return (
    <>
      <EmptyStateContainer>
        <StyledH1>Build Your IVR</StyledH1>
        <EmptyStateText>
          We recommend you start with the Basic IVR template and
          <br /> build from there. Otherwise, start from scratch!
        </EmptyStateText>

        <Button
          data-aid="start-building-button"
          disabled={disabled}
          onClick={() => setShowSelectNodeTypeModal(true)}
          type={Button.Types.SECONDARY}
        >
          Start Building
        </Button>
      </EmptyStateContainer>
      {selectNodeTypeModal}
    </>
  );
};

const StyledH1 = styled(H1)`
  justify-content: center;
`;

const EmptyStateText = styled.div`
  margin-bottom: 20px;
`;

const EmptyStateContainer = styled.div`
  color: ${p => p.theme.colors.gray500};
  left: calc(50% - 200px);
  position: fixed;
  text-align: center;
  top: calc(50% - 100px);
  width: 400px;
  line-height: 162%;
`;

export default EmptyIvrState;
